import React from 'react';
import { Section } from '../Section';
import { SectionTitle, Paragraph } from '../Typography';
import { mediaQueries } from '../../style/breakpoints';
import { AnchorButton } from '../Button';
import { useMediaQueries } from '../../utils/MediaQueries';

/**
 * @type React.FunctionComponent<{ withoutCenteredContent?: boolean}>
 */

const IntraCompany = ({ withoutCenteredContent, isSessionName, formationName }) => {
  const mqs = useMediaQueries();
  return (
    <Section
      theme="ternary"
      withoutCenteredContent={withoutCenteredContent}
      css={{
        [mediaQueries.phoneOnly]: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        },
        [mediaQueries.tabletLandscapeUp]: {
          paddingLeft: isSessionName ? 85 : 0,
        },
      }}
    >
      {mqs.tabletLandscapeUp && isSessionName ? (
        <SectionTitle css={{ [`@media only screen and (width: 1024px)`]: { fontSize: 44 } }}>
          Intéressé par <br />
          une formation <br /> intra-entreprise ?
        </SectionTitle>
      ) : (
        <SectionTitle
          css={{
            [mediaQueries.phoneOnly]: {
              justifyContent: 'center',
              textAlign: 'center',
            },
          }}
        >
          Intéressé par une formation <br />
          intra-entreprise ?
        </SectionTitle>
      )}

      <Paragraph
        css={{
          [mediaQueries.phoneOnly]: {
            justifyContent: 'center',
            textAlign: 'center',
            padding: '32px 0',
          },
        }}
      >
        Nos formateurs se déplacent dans toute la France et à l’étranger.
      </Paragraph>
      <div>
        <AnchorButton
          to="/devis/"
          state={{ fromFormationPage: formationName }}
          css={{
            [mediaQueries.phoneOnly]: {
              width: '100%',
            },
          }}
        >
          Demander un devis
        </AnchorButton>
      </div>
    </Section>
  );
};

export default IntraCompany;
